import { render, staticRenderFns } from "./SmsAbandonedCarts2.vue?vue&type=template&id=dd21d5aa&scoped=true&"
import script from "./SmsAbandonedCarts2.vue?vue&type=script&lang=js&"
export * from "./SmsAbandonedCarts2.vue?vue&type=script&lang=js&"
import style0 from "./SmsAbandonedCarts2.vue?vue&type=style&index=0&id=dd21d5aa&scoped=true&lang=css&"
import style1 from "./SmsAbandonedCarts2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd21d5aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDivider,VExpandTransition,VRow,VSelect,VSwitch,VTextarea,VTooltip})
